// extracted by mini-css-extract-plugin
module.exports = {"smp8yyz":"smp8yyz","w1g0kvz6":"w1g0kvz6"};